import { CONTACT_LISTS_API_URL } from 'constants/ApiConstants';
import * as types from 'modules/contactLists/actionTypes';

export const isInitialized = (meta = {}) => ({
  type: types.DETAILS_INITIALIZED,
  meta,
});

/** @type {import("../types").OpenExportAction} */
export const openExport = (contactListId, meta = {}) => ({
  type: types.OPEN_EXPORT,
  payload: contactListId,
  meta,
});

/** @type {import("../types").CloseExportAction} */
export const closeExport = (meta = {}) => ({
  type: types.CLOSE_EXPORT,
  meta,
});

/** @type {import("../types").ExportContactListAction} */
export const exportContactList = (contactListId, data, meta = {}) => ({
  type: types.EXPORT_CONTACT_LIST,
  payload: {
    request: {
      method: 'POST',
      url: `${CONTACT_LISTS_API_URL}/${contactListId}/export`,
      data,
    }
  },
  meta,
});
